import FiltersQuery from './FiltersQuery';

export default {
    mixins: [FiltersQuery],
    data() {
        return {
            activeFilters: {},
            layoutData: [],
            resetFilters: false,
            storeFilterKey: '',
        }
    },
    computed: {
        ordersFilters() {
            return this.$store.state.ordersFilters;
        },
    },
}
